import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { CatalogTreeCardObject } from 'src/app/models/catalog/catalog-tree-item-object.model';
import { TreeItemObject } from 'src/app/models/catalog/tree-item-object.model';

@Component({
    selector: 'app-catalog-tree',
    templateUrl: './catalog-tree.component.html',
    styleUrls: ['./catalog-tree.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogTreeComponent implements OnInit{
    @Input() node: TreeItemObject;
    @Input() selectedNode: TreeItemObject;
    @Output() clickCard = new EventEmitter<TreeItemObject>();


    onClickCard($event: TreeItemObject) {
        this.clickCard.emit($event);
    }

    constructor() {
    }

    ngOnInit() {
    }

}
